interface IQuestionRootProps extends ICustomizable {
  children: React.ReactNode;
}

export const QuestionRoot = (props: IQuestionRootProps) => {
  return <div className={props.className}>{props.children}</div>;
};
